// extracted by mini-css-extract-plugin
export var active = "_65-a";
export var activeIndicator = "_65-8";
export var animate = "_65-9";
export var disabled = "_65-b";
export var fullWidth = "_65-2";
export var lg = "_65-7";
export var md = "_65-6";
export var redoButtonTabGroup = "_65-0";
export var sm = "_65-5";
export var tabButton = "_65-3";
export var tabButtonsContainer = "_65-1";
export var xs = "_65-4";